// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ml-z","subtitle":"Nl-z","contentWrap":"Ol-z","imgWrap":"Pl-z","heading":"Ql-z","copy":"Rl-z"};